<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý cộng tác viên</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="importFile()"
          v-if="dataPermission && dataPermission.includes('CNPS_AGENT_IMPORT')"
        >
          <i class="bx bx-plus-circle"></i> Nhập file
        </button>
        <input ref="file" type="file" hidden />
        <button
          v-if="selected.length > 0"
          class="font-medium f12 btn btn-outline-secondary"
          @click="assignSaleLead"
          title="Gán CTV"
        >
          Gán CTV
        </button>
        <!-- <button class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button> -->
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.name"
              class="form-control f12 hc-37"
              placeholder="Tên"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.mobile"
              class="form-control f12 hc-37"
              placeholder="Số điện thoại"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.email"
              class="form-control f12 hc-37"
              placeholder="Email"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.agentGroup" :options="dataAgency" placeholder="Loại agency" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="dataRegion"
              @change="queryProvince($event)"
              placeholder="Vùng"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.saleLeaderEmail"
              :options="dataSaleLead"
              placeholder="Sale lead"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.stateAgent"
              :options="statusActive"
              placeholder="Trạng thái tài khoản"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.identityStatus"
              :options="statusConfirm"
              placeholder="Trạng thái chứng thực"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body" v-if="dataPermission && dataPermission.includes('CNPS_AGENT_LIST')">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng cộng tác viên: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataCTV"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <input type="checkbox" v-model="selectAll" />
              </template>
              <template #cell(selected)="data">
                <input type="checkbox" v-model="selected" :value="data.item" number />
              </template>
              <template #cell(time)="data">
                <b>Tạo:</b> {{ data.item.createdDate | formatTime }}
                <div v-if="data.item.updatedDate">
                  <b>Cập nhật: </b>{{ data.item.updatedDate | formatTime }}
                </div>
              </template>
              <template #cell(info)="data">
                <div v-if="data.item.name">
                  <b>{{ data.item.name }}</b>
                </div>
                <div v-if="data.item.mobile">{{ data.item.mobile }}</div>
                <div v-if="data.item.email">
                  <a href="#">{{ data.item.email }}</a>
                </div>
              </template>
              <template #cell(address)="data">
                <p>{{ data.item.address }}</p>
                <b
                  v-if="
                    data.item.districtName &&
                    data.item.districtName !== null &&
                    data.item.districtName !== ''
                  "
                  >{{ data.item.districtName }},</b
                ><b> {{ data.item.cityName }}</b>
              </template>
              <template #cell(saleLeader)="data">
                <div v-if="data.item.saleLeader">
                  {{ data.item.saleLeader.name }}<br />
                  {{ data.item.saleLeader.mobile }}<br />
                  <a href="#">{{ data.item.saleLeader.email }}</a>
                </div>
              </template>
              <template #cell(stateAgent)="data">
                <span class="badge" :class="[data.item.stateAgent ? data.item.stateAgent : '']">
                  {{ data.item.stateAgent | mapTextStatus(dataStatus) }}
                </span>
              </template>
              <template #cell(identityStatus)="data">
                <span
                  class="badge"
                  :class="[data.item.identityStatus ? data.item.identityStatus : '']"
                >
                  {{ data.item.identityStatus | mapTextStatus(statusConfirm) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown variant="outline-light">
                  <b-dropdown-item
                    @click="collaboratorDetail(data.item)"
                    v-if="dataPermission && dataPermission.includes('CNPS_AGENT_DETAIL')"
                    >Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="lockOrActive(data.item)"
                    v-if="dataPermission && dataPermission.includes('CNPS_AGENT_UPDATE_STATE')"
                  >
                    <span v-if="data.item.stateAgent === 'ACTIVE'">Khóa</span>
                    <span v-else>Mở khoá</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>
    <!--Modal reset mật khẩu-->
    <b-modal id="modal-scoped" v-model="resetPassModal">
      <template #modal-header="{ close }">
        <h5>Reset mật khẩu cộng tác viên</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6>Bạn chắc chắn muốn reset mật khẩu cộng tác viên {{ nameReset }} - {{ emailReset }} ?</h6>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button variant="primary" @click="confirmReset"> Reset mật khẩu </b-button>
      </template>
    </b-modal>
    <!-- Modal gán quyền -->
    <b-modal id="modal-scoped" v-model="assignPermissionModal">
      <template #modal-header="{ close }">
        <h5>Gán quyền</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="modal-body" style="max-height: 500px; overflow-y: auto">
        <h1 class="py-3 f16">
          Cộng tác viên: {{ nameAssign }}
          <br />
          <span class="badge badge-primary">Mã CTV: {{ agentIdAssign }} </span>
        </h1>
        <li>
          <label class="tree-container">
            Tất cả
            <input type="checkbox" v-model="selectAllRole" />
            <span class="tree-checkmark"></span>
          </label>
        </li>
        <ul class="ql-ganquyen" v-for="(item, index) in dataRole" :key="index">
          <li>
            <label class="tree-container">
              {{ item.name }}
              <input
                type="checkbox"
                @change="changeRole($event, item.name)"
                :value="item.name"
                number
                :checked="checkedRole(item.name)"
              />
              <span class="tree-checkmark"></span>
            </label>
          </li>
        </ul>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Hủy bỏ </b-button>
        <b-button variant="primary" @click="confirmAssign"> Lưu </b-button>
      </template>
    </b-modal>

    <!-- Modal khóa/mở ctv-->
    <b-modal id="modal-scoped" v-model="lockModal">
      <template #modal-header="{ close }">
        <h5 v-if="stateCTV === 'ACTIVE'">Khóa cộng tác viên</h5>
        <h5 v-else>Mở cộng tác viên</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6 v-if="stateCTV === 'ACTIVE'" class="text-center">
        Bạn chắc chắn muốn khóa cộng tác viên viên {{ nameLock }} - {{ emailLock }} ?
      </h6>
      <h6 v-else>Bạn chắc chắn muốn mở khóa cộng tác viên {{ nameLock }} - {{ emailLock }} ?</h6>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button variant="primary" @click="confirmLockOrActive"> Đồng ý </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!--Modal gán CTV cho sale leader-->
    <b-modal id="modal-scoped" v-model="showListSaleLead">
      <template #modal-header="{ close }">
        <h5>Chọn sale leader</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <p>Hãy nhập tên sale leader</p>
      <vue-simple-suggest
        display-attribute="text1"
        value-attribute="id"
        :list="dataSaleSelect"
        :filter-by-query="true"
        @select="onSuggestSelect"
      >
      </vue-simple-suggest>

      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="primary" @click="assignAgentToLead"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { AgentService } from '@/services/agent.service'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import { StaffService } from '@/services/staff.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  const fieldsTable = [
    { key: 'selected' },
    { key: 'time', label: 'Thời gian' },
    { key: 'info', label: 'Họ tên' },
    { key: 'address', label: 'Địa chỉ' },
    { key: 'saleLeader', label: 'Sale lead' },
    { key: 'agentGroupName', label: 'Loại CTV' },
    { key: 'stateAgent', label: 'Trạng thái' },
    { key: 'identityStatus', label: 'Trạng thái chứng thực' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin],
    components: {
      VueSimpleSuggest,
    },
    data() {
      return {
        dataCTV: [],
        fieldsTable,
        filterTable: fieldsTable,
        loading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataStatus: [
          { text: 'Hoạt động', id: 'ACTIVE' },
          { text: 'Khóa', id: 'LOCKED' },
        ],
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        resetPassModal: false,
        nameReset: '',
        emailReset: '',
        agentIdReset: '',
        nameAssign: '',
        agentIdAssign: '',
        assignPermissionModal: false,
        dataRole: [],
        dataRoleSelect: [],
        roleOfAgent: [],
        stateCTV: '',
        agentIdLock: '',
        nameLock: '',
        emailLock: '',
        lockModal: false,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        dataRegion: [],
        dataProvince: [],
        dataSaleLead: [],
        statusActive: [
          { id: 'ACTIVE', text: 'Đang hoạt động' },
          { id: 'LOCKED', text: 'Đã khóa' },
        ],
        statusConfirm: [
          { id: 'ACTIVE', text: 'Đã chứng thực' },
          { id: 'REFUSE', text: 'Đã từ chối' },
          { id: 'PENDING', text: 'Chờ xác thực' },
          { id: 'NOT_YET', text: 'Chưa có ảnh' },
        ],
        dataAgency: [
          { id: 'MSB', text: 'MSB' },
          { id: 'NEXTPAY', text: 'NEXTPAY' },
          { id: 'NEXTPAY_INDIVIDUAL', text: 'Nextpay Cá nhân' },
        ],
        selected: [],
        showListSaleLead: false,
        dataSaleSelect: [],
        saleLeadInfo: {},
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    async mounted() {
      await this.getRegions()
      this.getDataSearch()
      this.fetchData()
      this.getRole()
      this.listSaleLead()
      this.getListStaffLower()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAllRole: {
        get: function () {
          return this.dataRole && this.roleOfAgent
            ? this.roleOfAgent.length === this.dataRole.length
            : false
        },
        set: function (value) {
          var dataRoleSelect = []
          if (value) {
            this.dataRole.forEach(function (item) {
              dataRoleSelect.push(item.name)
            })
          }
          // this.dataRoleSelect = dataRoleSelect
          this.roleOfAgent = dataRoleSelect
        },
      },
      selectAll: {
        get: function () {
          return this.dataCTV ? this.selected.length === this.dataCTV.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataCTV.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
    },
    methods: {
      // nhập file
      importFile() {
        this.$router.push('/import-collaborators')
      },
      // chuyển trang chi tiết
      collaboratorDetail(item) {
        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
        window.open(`/list-collaborators/${item.agentId}`)
      },
      // reset password ctv
      resetPassword(item) {
        this.resetPassModal = true
        this.nameReset = item.name
        this.emailReset = item.email
        this.agentIdReset = item.agentId
      },
      // define ngày trên lịch
      transformDate() {
        this.search.createdDateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.createdDateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.code, text: e.name, region: e.id }
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const region = this.dataRegion.find(a => a.id === e)
          const data = await StaffService.getProvinceRegion({ regionId: [region.region] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      // lấy list sale lead
      async listSaleLead() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.dataSaleLead = data.data.map(e => {
              return { id: e.userName, text: e.name }
            })
          }
        } catch (error) {}
      },
      // confirm reset pass
      async confirmReset() {
        this.resetPassModal = false
        try {
          const data = await AgentService.resetPassAgent({
            agentId: this.agentIdReset,
          })
          if (data.success) {
            this.notiModal = true
            this.msgNoti = data.message
            this.iconNoti = require('@/assets/img/noti-success2.svg')
          } else {
            this.notiModal = true
            this.msgNoti = data.message
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          }
        } catch (error) {
          console.log(error)
        }
      },
      // list role gán quyền
      async getRole() {
        try {
          const data = await CommonService.getAllRole({})
          if (data.success) {
            data.data.map(e => this.dataRole.push({ name: e.name }))
          }
        } catch (error) {
          console.log(error)
        }
      },
      // get Role của CTV
      async getRoleByAgent() {
        try {
          const data = await AgentService.getRole({ agentId: this.agentIdAssign })
          if (data.success) {
            this.roleOfAgent = data.data.listRole
            return
          }
        } catch (error) {
          console.log(error)
        }
      },
      // check xem CTV đang có những role gì, khi mở modal hiển thị các role đó dc check
      checkedRole(role) {
        return this.roleOfAgent && this.roleOfAgent.length ? this.roleOfAgent.includes(role) : false
      },
      changeRole(event, role) {
        const checked = event.target.checked
        if (checked) {
          this.roleOfAgent.push(role)
        } else {
          this.roleOfAgent = this.roleOfAgent.filter(e => e !== role)
        }
      },
      // Gán quyền
      async assignPermission(item) {
        this.assignPermissionModal = true
        this.nameAssign = item.name
        this.agentIdAssign = item.agentId
        await this.getRoleByAgent()
      },
      // confirm gán quyền
      async confirmAssign() {
        try {
          const params = {
            roles: this.roleOfAgent,
            agentId: this.agentIdAssign,
          }
          const data = await AgentService.setRole(params)
          if (data.success) {
            this.assignPermissionModal = false
            this.notiModal = true
            this.msgNoti = data.message
            this.iconNoti = require('@/assets/img/noti-success2.svg')
          } else {
            this.assignPermissionModal = false
            this.notiModal = true
            this.msgNoti = data.message
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Khóa và mở khóa
      lockOrActive(item) {
        this.lockModal = true
        this.agentIdLock = item.agentId
        this.nameLock = item.name
        this.emailLock = item.email
        this.stateCTV = item.stateAgent
      },
      async confirmLockOrActive() {
        try {
          this.lockModal = false
          if (this.stateCTV === 'ACTIVE') {
            const response = await AgentService.lockOrActiveCTV({
              agentId: this.agentIdLock,
              state: 'LOCKED', // ACTIVE,  LOCKED
            })
            if (response.success) {
              this.notiModal = true
              this.msgNoti = response.message
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.stateCTV = 'LOCKED'
            } else {
              this.notiModal = true
              this.msgNoti = response.message
              this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            }
          } else {
            const response = await AgentService.lockOrActiveCTV({
              agentId: this.agentIdLock,
              state: 'ACTIVE',
            })
            if (response.success) {
              this.notiModal = true
              this.msgNoti = response.message
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.stateCTV = 'ACTIVE'
            } else {
              this.notiModal = true
              this.msgNoti = response.message
              this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            }
          }
          this.fetchData()
        } catch (error) {
          console.log(error)
        }
      },
      // list sale lead gán
      async getListStaffLower(params) {
        try {
          const data = await StaffService.getListLowerGrade(params)
          if (data.data.length > 0) {
            this.dataSaleSelect = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
                mobile: e.mobile,
                email: e.userName,
                text1: e.name + ' - ' + e.userName,
              }
            })
          }
        } catch (error) {}
      },
      // show modal gán ctv
      assignSaleLead() {
        const arr = this.selected.map(e => {
          return e.regionId
        })
        const isExist = (arr, x) => {
          for (const i in arr) {
            if (arr[i] === x) return true
          }
          return false
        }
        const ans = []
        arr.forEach(element => {
          if (!isExist(ans, element)) ans.push(element)
        })
        if (ans.length > 1) {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Cộng tác viên đã chọn không cùng vùng với nhau!'
          this.selected = []
        } else {
          this.showListSaleLead = true
          this.getListStaffLower({
            userId: this.dataUser.userId,
            region: ans,
          })
        }
      },
      // lấy thông tin sale lead
      onSuggestSelect(suggest) {
        this.saleLeadInfo = suggest
      },
      // confirm gán ctv cho sale lead
      async assignAgentToLead() {
        const agentIds = []
        this.selected.map(e => agentIds.push(e.agentId))
        try {
          const data = await AgentService.assignAgentToLead({
            agentIds: agentIds,
            saleLeaderEmail: this.saleLeadInfo.email,
            saleLeaderMobile: this.saleLeadInfo.mobile,
            saleLeaderName: this.saleLeadInfo.text,
          })
          if (data.success) {
            this.showListSaleLead = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Gán thành công'
            this.selected = []
            this.fetchData()
          } else {
            this.showListSaleLead = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.selected = []
            this.fetchData()
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.selected = []
        await this.fetchData()
      },
      // data bảng
      async fetchData() {
        try {
          this.loading = true
          if (this.search.stateAgent === '0') delete this.search.stateAgent
          const data = await AgentService.getListAgent(this.search)
          if (data.success) {
            this.dataCTV = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            limit: 50,
            page: 1,
          }
        } else {
          this.search = this.dataSearch
          if (this.search.regionCode) this.queryProvince(this.search.regionCode)
          this.fetchData()
        }
      },
    },
  }
</script>
